import { render, staticRenderFns } from "./ManageCompany.html?vue&type=template&id=2c807cb2&lang=html&external"
import script from "./ManageCompany.vue?vue&type=script&lang=js"
export * from "./ManageCompany.vue?vue&type=script&lang=js"
import style0 from "./ManageCompany.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports